export class DropdownHelperModel {
  id: number | string;
  name: string
}
